export default "__VITE_ASSET__BpTPAxg5__"